module.exports = __webpack_public_path__ + "img/cat-01.3541306e.png";